export const version = "networks/5.1.0";
//# sourceMappingURL=_version.js.map